<header class="border-b border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-950 sticky top-0 z-40">
  <div class="container mx-auto px-4">
    <div class="flex h-16 items-center justify-between">
      <hlm-sheet #sheetRef [side]="'left'" class="md:hidden">
        <button brnSheetTrigger hlmBtn [size]="'icon'" [variant]="'ghost'">
          <ng-icon hlm [size]="'base'" [name]="'lucideMenu'" />
        </button>
        <hlm-sheet-content *brnSheetContent="let ctx">
          <hlm-sheet-header class="flex items-start justify-center">
            <a
              routerLink="/"
              (click)="sheetRef.close({})"
              class="rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ring-offset-background"
            >
              <app-logo-with-text />
            </a>
          </hlm-sheet-header>
          <ul class="flex flex-col mt-6 space-y-6">
            <li>
              <a
                hlmBtn
                [variant]="'ghost'"
                [size]="'sm'"
                routerLink="/"
                routerLinkActive="bg-accent text-accent-foreground"
                [routerLinkActiveOptions]="{ exact: true }"
                class="w-full justify-start"
                (click)="sheetRef.close({})"
              >
                Home
              </a>
            </li>
            <li>
              <a
                hlmBtn
                [variant]="'ghost'"
                [size]="'sm'"
                routerLink="/news"
                routerLinkActive="bg-accent text-accent-foreground"
                class="w-full justify-start"
                (click)="sheetRef.close({})"
              >
                News
              </a>
            </li>
            <li>
              <a
                hlmBtn
                [variant]="'ghost'"
                [size]="'sm'"
                routerLink="/mcp-servers"
                routerLinkActive="bg-accent text-accent-foreground"
                class="w-full justify-start"
                (click)="sheetRef.close({})"
              >
                MCP Servers
              </a>
            </li>
            <li>
              <a
                hlmBtn
                [variant]="'ghost'"
                [size]="'sm'"
                routerLink="/mcp-clients"
                routerLinkActive="bg-accent text-accent-foreground"
                class="w-full justify-start"
                (click)="sheetRef.close({})"
              >
                MCP Clients
              </a>
            </li>
            <li>
              <a
                hlmBtn
                [variant]="'ghost'"
                [size]="'sm'"
                routerLink="/about"
                routerLinkActive="bg-accent text-accent-foreground"
                class="w-full justify-start"
                (click)="sheetRef.close({})"
              >
                About
              </a>
            </li>
            <li>
              <a hlmBtn [size]="'sm'" routerLink="/subscribe" class="w-full" (click)="sheetRef.close({})">Subscribe</a>
            </li>
          </ul>
        </hlm-sheet-content>
      </hlm-sheet>

      <!-- Logo and brand -->
      <a
        routerLink="/"
        class="flex items-center space-x-3 rounded-md group/logo transition-opacity hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ring-offset-background"
      >
        <app-logo-icon
          [animated]="true"
          class="transition-all group-hover/logo:rotate-[-10deg] group-hover/logo:scale-105"
        />
        <span class="text-lg font-bold text-gray-900 dark:text-gray-100">Summerry</span>
      </a>

      <!-- Desktop Navigation -->
      <nav class="hidden md:block">
        <ul class="flex items-center space-x-6">
          <li>
            <a
              hlmBtn
              [variant]="'link'"
              [size]="'sm'"
              routerLink="/"
              routerLinkActive="underline"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              Home
            </a>
          </li>
          <li>
            <a hlmBtn [variant]="'link'" [size]="'sm'" routerLink="/news" routerLinkActive="underline"> News </a>
          </li>
          <li>
            <a hlmBtn [variant]="'link'" [size]="'sm'" routerLink="/mcp-servers" routerLinkActive="underline">
              MCP Servers
            </a>
          </li>
          <li>
            <a hlmBtn [variant]="'link'" [size]="'sm'" routerLink="/mcp-clients" routerLinkActive="underline">
              MCP Clients
            </a>
          </li>
          <li>
            <a hlmBtn [variant]="'link'" [size]="'sm'" routerLink="/about" routerLinkActive="underline"> About </a>
          </li>
          <li>
            <a hlmBtn [size]="'sm'" routerLink="/subscribe"> Subscribe </a>
          </li>
          <li class="hidden md:block">
            <button
              hlmBtn
              [size]="'icon'"
              [variant]="'ghost'"
              [ariaLabel]="'Toggle dark mode'"
              (click)="toggleDarkMode()"
            >
              <ng-icon hlm [size]="'sm'" [name]="'lucideMoon'" class="flex dark:hidden" />
              <ng-icon hlm [size]="'sm'" [name]="'lucideSun'" class="!hidden dark:!flex" />
            </button>
          </li>
        </ul>
      </nav>

      <button
        hlmBtn
        [size]="'icon'"
        [variant]="'ghost'"
        [ariaLabel]="'Toggle dark mode'"
        (click)="toggleDarkMode()"
        class="md:hidden"
      >
        <ng-icon hlm [size]="'base'" [name]="'lucideMoon'" class="flex dark:hidden" />
        <ng-icon hlm [size]="'base'" [name]="'lucideSun'" class="!hidden dark:!flex" />
      </button>
    </div>
  </div>
</header>
